import { render } from "./Change-wizard-card.vue?vue&type=template&id=8036c3ba&scoped=true"
import script from "./Change-wizard-card.vue?vue&type=script&lang=js"
export * from "./Change-wizard-card.vue?vue&type=script&lang=js"

import "./Change-wizard-card.vue?vue&type=style&index=0&id=8036c3ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8036c3ba"]])

export default __exports__